import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MdDialogRef, MdDialog, MdDialogConfig, MdSelect} from '@angular/material';
import {
  NegociosService,
  ColaboradoresService,
  CONFIRMACION_VALUES,
  PosicionService,
  EntregaService,
  SpinnerService,
  NEGOCIO_TYPE_NEGOCIO_OLVIDADO_ID,
  DOLAR_PESOS_ID,
  PreciosService,
  CommonService,
} from '../../../services';
import { CuentaAutocompleteComponent, ColaboradorAutocompleteComponent, AcopioAutocompleteComponent } from '../../../components/common/autocomplete';

import {dateToUnixTime, parseDate} from '../../../utils/DateHelper';

import * as moment from 'moment';
import { MonedaService, MONEDA_PESIFICACION } from '../../../services/moneda-service';
import { ProductoService } from '../../../services/producto-service';
import { CosechaService } from '../../../services/cosecha-service';
import {ClienteSaldoListComponent} from "../../common/cliente-saldo-list/cliente-saldo-list.component";
import { TextDialogComponent } from '../../common/dialog/text-dialog/text-dialog.component';
import { MdSelectFilterComponent } from '../../common/md-select-filter/md-select-filter.component';
import { PermisosService, PERM_ACCIONES_ID } from '../../../services/permisos-service';
import {PrecioMonitor} from '@common/precio-monitor';

@Component({
  selector: 'app-new-negocio-dialog',
  templateUrl: './new-negocio-dialog.component.html',
  styleUrls: ['./new-negocio-dialog.component.scss']
})
export class NewNegocioDialogComponent implements OnInit, OnDestroy {

  public id: number;
  public selectedCuenta: any;
  public negocio: any = {};
  private entrega = null;
  private negocioTipo = null;
  public isDuplicate: boolean = false;
  public fromPrecio: PrecioMonitor = null;

  public title: string;

  private saving: boolean = false;

  private observPlace = 'Observaciones';

  @ViewChild('vencimientoDatePicker') vencimientoDatePicker;
  @ViewChild('creacionDatePicker') creacionDatePicker;

  @ViewChild(CuentaAutocompleteComponent) cuentaAutocompleteComponent;
  @ViewChild(ColaboradorAutocompleteComponent) colaboradorAutocompleteComponent;
  @ViewChild(ClienteSaldoListComponent) clienteSaldoListComponent;

  private forwardNegocioID;
  private cosechaOptions = [];
  private entregaOptions = [];
  private tipoOptions = [];
  private productoOptions = [];
  private negocioOptions = [];
  private monedaOptions = [];
  private currentMonedaOptions = [];
  private currentEntregaOptions = [];
  private customNotification: boolean = false;
  private mercadosOptions = [];

  @ViewChild('observacionArea') observacionArea;
  private observacionRows: number = 1;

  private typeNotif: number = 1;  // 1: hours, 24: days, 168: weeks
  private maxNotif: number = 24;
  private minNotif: number = 1;
  private horasVencimiento = '1';

  private errors: string = '';

  private current = moment().subtract(1, 'days').toDate();
  private vencimientoMax = moment().add(15, 'days').toDate();

  private responsableName: string;

  private confirmacionEstado: string;
  private matcheadaFlag: boolean = false;
  private isEdit: boolean = false;
  public showSpinner: boolean = false;
  private isRolEspecial: boolean = false;
  private posicionI;

  private firstDayMonthTime;
  private firstBusinessDay: boolean = false;

  private colaboradoresValid = true;
  private NEGOCIO_OLVIDADO_ID = NEGOCIO_TYPE_NEGOCIO_OLVIDADO_ID;

  negocioOlvidadoValidado: boolean = null;
  @ViewChild(MdSelectFilterComponent) acopioSelector: MdSelectFilterComponent;

  private showTnsSpan = false;
  @ViewChild('tnsInput') tnsInput: ElementRef;
  MONEDA_PESIFICACION = MONEDA_PESIFICACION;

  cuentaAcopioError = false;
  acopioSelectorItems = [];

  cosechaValidated = false;
  @ViewChild('cosechaSelect') cosechaSelect: MdSelect;

  constructor(
    public dialogRef: MdDialogRef<NewNegocioDialogComponent>,
    private negociosService: NegociosService, private monedaService: MonedaService,
    private posicionService: PosicionService, private productoService: ProductoService,
    private cosechaService: CosechaService, private entregaService: EntregaService,
    private colaboradoresService: ColaboradoresService, private spinnerService: SpinnerService,
    private permisosService: PermisosService, private dialog: MdDialog,
    private preciosService: PreciosService, private commonService: CommonService) {
    if (!this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.A_CrearNegocio)) {
      this.permisosService.mostrarSnackbarAdvertencia();
      this.dialogRef.close(false);
    }
    monedaService.Options.subscribe(newValue => {
      if (newValue.length) {
        this.monedaOptions = [...newValue, this.MONEDA_PESIFICACION];
      }
    });
    this.productoService.loadOptions();
    productoService.Options.subscribe(newValue => {
      this.productoOptions = newValue;
    });
    cosechaService.Options.subscribe(newValue => {
      this.cosechaOptions = newValue.sort(function (a, b) { return b.Desde - a.Desde });
    });
    entregaService.ForwardNegocioID.subscribe(newValue => {
      this.forwardNegocioID = newValue;
    });
    entregaService.PosicionOptions.subscribe(newValue => {
      this.entregaOptions = newValue;
      this.changedNegocio({value: this.negocioTipo});
    });
    preciosService.getMercadosPizarra().take(1).subscribe(x => {
      this.mercadosOptions = x.filter(y => y.Visibilidad);
      if (!this.id && !this.fromPrecio) {
        this.negocio['MercadoId'] = this.mercadosOptions.length ? this.mercadosOptions[0].Id : null;
      }
    });
  }

  ngOnInit() {
    let tmpToday = new Date();
    this.firstDayMonthTime = new Date(tmpToday.getFullYear(), tmpToday.getMonth(), 1).getTime();
    this.tipoOptions = this.negociosService.getTipoSelectOptions().filter(x => x.ID === 1 || x.ID === 2 || x.ID === 6);
    this.negocioOptions = this.negociosService.getNegocioSelectOptions().slice(0, 3);

    if (this.id) {
      this.negociosService.setCurrentNegocio(this.id).subscribe(res => {});
      this.setupEditNegocio();
    }
    if (this.selectedCuenta) {
      this.cuentaAutocompleteComponent.selectedCuentas = [this.selectedCuenta];
    }
    if (!this.id || this.isDuplicate) {
      this.showSpinner = true;
      this.colaboradoresService.getColaborador(Number(localStorage.getItem('userId'))).subscribe(data => {
        this.responsableName = data.UserFullName;
        this.showSpinner = false;
      });
    }

    // Controlar si el primer día hábil del mes es igual al actual
    this.commonService.getFirstBusinessDay().subscribe(data => {
      this.firstBusinessDay = moment().startOf('day').isSame(data, 'day'); // Granularidad a nivel año, mes, y día
    })
	
    if (this.fromPrecio !== null) {
      // tenemos un precio, seteamos los valores que provienen del precio
      this.setupNegocioFromPrecio();
    }

    // posicion interval
    clearInterval(this.posicionI);
    this.posicionService.loadOptions();
    this.posicionI = setInterval(_=>this.posicionService.loadOptions(), 40000);
  }

  ngOnDestroy() {
    clearInterval(this.posicionI);
    this.negociosService.removeCurrentNegocio().subscribe(res => {});
  }

  setupEditNegocio() {
    this.showSpinner = true;
    this.negociosService.getNegocio(this.id).subscribe(data => {
      this.cuentaAutocompleteComponent.selectedCuentas = [data.ResponseData.Cliente];
      this.negocio.TipoNegocioId = data.ResponseData.TipoNegocio.Id;
      this.negocio.FechaCreacion = new Date(data.ResponseData.Fecha);
      this.negocio.FechaCreacion = parseDate(this.negocio.FechaCreacion);
      this.negocio.ProductoId = data.ResponseData.Producto.Id;
      this.colaboradorAutocompleteComponent.productoSelected = data.ResponseData.Producto.Id;
      this.negocio.CosechaId = data.ResponseData.Cosecha.Id;
      this.negocio.Toneladas = String(data.ResponseData.Toneladas).replace('.', ',');
      if (!isNaN(data.ResponseData.Toneladas)) {
        this.addMagnitudePoints('Toneladas');
        this.showTnsSpan = true;
      }
      this.negocio.MercadoId = data.ResponseData.Mercado.Id;

      // Entrega/Posición y Negocio
      if (data.ResponseData.Entrega.EsPosicion) {
        this.changedNegocio({ value: 'FORWARD' });
        this.negocioTipo = this.negocioOptions[1].value;
        this.entrega = this.entregaOptions.find(e => e.ID_POS === data.ResponseData.NegocioTipoPosicion.Id);
      } else if (data.ResponseData.Entrega.Id === 4) {
          this.changedNegocio({ value: 'PAGO_DIFERIDO' });
          this.negocioTipo = this.negocioOptions[2].value;
          this.entrega = this.entregaOptions.find(e => e.ID_POS === data.ResponseData.NegocioTipoPosicion.Id);
      } else {
        this.changedNegocio({ value: 'DISPONIBLE' });
        this.negocioTipo = this.negocioOptions[0].value;
        this.entrega = this.entregaOptions.find(e => e.ID === data.ResponseData.Entrega.Id);
      }

      this.negocio.MonedaId = data.ResponseData.Moneda.Id;
      this.negocio.Base = String(data.ResponseData.Base).replace('.', ',');
      if (!isNaN(data.ResponseData.Base)) {
        this.addMagnitudePoints('Base');
      }
      this.negocio.Vencimiento = new Date(data.ResponseData.Vencimiento);
      this.negocio.AcopioId = data.ResponseData.Acopio.Id;

      this.onClienteSelected(this.negocio.AcopioId);


      if (!this.isDuplicate) {
        this.responsableName = data.ResponseData.Responsable.UserFullName;
        this.negocio.Id = this.id;
      }

      this.colaboradorAutocompleteComponent.selectedColaboradores = data.ResponseData.Colaboradores ? data.ResponseData.Colaboradores.slice() : [];
      this.colaboradorAutocompleteComponent.checkAll();

      this.negocio.Observaciones = data.ResponseData.Observaciones || '';

      this.negocio.PrecioEspecial = data.ResponseData.PrecioEspecial;
      this.negocio.PrecioIdea = data.ResponseData.PrecioIdea;
      this.negocio.Match = data.ResponseData.Match;

      this.negocio.UserId = data.ResponseData.Responsable.UserId;

      this.negocio.Vencimiento = parseDate(this.negocio.Vencimiento);

      this.confirmacionEstado = data.ResponseData.Confirmacion.Estado;
      this.matcheadaFlag = this.confirmacionEstado === CONFIRMACION_VALUES.MATCHEADA;
      this.customNotification = data.ResponseData.CustomNotification;
      if(data.ResponseData.CustomNotification){
        if(data.ResponseData.HorasNotificacion >= 168){
          this.typeNotif = 168;
        }else if(data.ResponseData.HorasNotificacion >= 24){
          this.typeNotif = 24;
        }else{
          this.typeNotif = 1;
        }

        this.horasVencimiento = (Number(data.ResponseData.HorasNotificacion) / this.typeNotif).toString();
      }
      this.isEdit = true;
      this.searchCuentaSaldo();
      this.showSpinner = false;
    });
  }

  onSubmit() {

    this.saving = true;
    this.spinnerService.setShowFlag(true);

    this.errors = '';
    let stopSubmit = false;

    if (!this.isFormValid()) {
      this.errors = 'El formulario está incompleto o incorrecto. Los elementos con * son requeridos.';
      stopSubmit = true;
    }

    if (!this.colaboradoresValid) {
      stopSubmit = true;
    }

    // Negocio Olvidado
    if ((this.negocio['TipoNegocioId'] === 6 && this.negocioOlvidadoValidado === null) && !stopSubmit) {
      this.validarNegOlvidado();
      stopSubmit = true;
	}

    // validamos la cosecha en caso de ser un disponible
    if (this.negocioTipo === 'DISPONIBLE' && !stopSubmit && !this.cosechaValidated) {
      const currentYear = moment().year();
      if (this.cosechaOptions.find(x => x.ID === this.negocio.CosechaId).Hasta > currentYear) {
        stopSubmit = true;
        // no podemos importar el dialog service dado que se genera una dependencia circular
        // por lo que debemos instanciar el componente manualmente
        let dialogRef: MdDialogRef<TextDialogComponent>;
        dialogRef = this.dialog.open(TextDialogComponent, { disableClose: true });
        dialogRef.componentInstance.title = 'Está intentando cargar un negocio disponible con una cosecha futura';
        dialogRef.componentInstance.message = '¿Está seguro que desea continuar?';
        dialogRef.componentInstance.positiveText = 'ACEPTAR';
        dialogRef.componentInstance.negativeText = 'CANCELAR';
        dialogRef.componentInstance.showNegativeButton = true;
        dialogRef.afterClosed().subscribe(x => {
          if (x) {
            this.cosechaValidated = true;
            this.onSubmit();
          } else {
            this.cosechaSelect.open();
          }
        });
      }
    }

    if (stopSubmit) {
      this.saving = false;
      this.spinnerService.setShowFlag(false);
      return;
    }

    if (this.negocio.Id) {
      if (this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.A_AutorNoAutor) && (
        this.confirmacionEstado === CONFIRMACION_VALUES.MATCHEADA ||
        this.confirmacionEstado === CONFIRMACION_VALUES.EN_PROCESO
      )) {
        this.saving = true;
      } else if (
        !(this.confirmacionEstado === CONFIRMACION_VALUES.ACTIVA ||
        this.confirmacionEstado === CONFIRMACION_VALUES.AUTORIZADA ||
        this.confirmacionEstado === CONFIRMACION_VALUES.MATCHEADA ||
        this.confirmacionEstado === CONFIRMACION_VALUES.NO_AUTORIZADA ||
        this.confirmacionEstado === CONFIRMACION_VALUES.VENCIDA)) {

        this.errors = 'Este negocio no puede editarse debido a su estado';
        this.saving = false;
        this.spinnerService.setShowFlag(false);
        return;
      }
    }

    this.negocio.AcopioId = this.acopioSelector.selectedItem;
    this.negocio.ClienteId = this.cuentaAutocompleteComponent.selectedCuentas[0].Id;
    this.negocio.Colaboradores = this.colaboradorAutocompleteComponent.selectedColaboradores.map(c => c.UserId);

    if(this.customNotification){
      this.negocio.CustomNotification = this.customNotification;
      this.negocio.HorasNotificacion = Number(this.horasVencimiento) * this.typeNotif;
    }

    // Entrega/Posicion y Negocio
    if (this.negocioTipo === 'DISPONIBLE') {
      this.negocio.EntregaId = this.entrega.ID;
      this.negocio.NegocioTipoPosicionId = null;
    } else if (this.negocioTipo === 'FORWARD') {
      this.negocio.EntregaId = this.forwardNegocioID;
      this.negocio.NegocioTipoPosicionId = this.entrega.ID_POS;
    } else if (this.negocioTipo === 'PAGO_DIFERIDO') {
      this.negocio.EntregaId = this.entrega.Entrega_Id;
      this.negocio.NegocioTipoPosicionId = this.entrega.ID_POS;
    }

    // Base y Toneladas. Quitar caracteres no numéricos
    const base = Number(this.negocio['Base'].replace(/[^0-9|,]/g, '').replace(',', '.'));
    const tns = Number(this.negocio['Toneladas'].replace(/[^0-9|,]/g, '').replace(',', '.'));


    if (this.negocio.Id) {
      this.negociosService.editNegocio({...this.negocio, 'Base': base, 'Toneladas': tns}).subscribe(res => {
        this.spinnerService.setShowFlag(false);
        this.saving = false;
        this.dialogRef.close(true);
      }, err => this.spinnerService.setShowFlag(false));
    } else {
      this.negociosService.addNegocio({...this.negocio, 'Base': base, 'Toneladas': tns}, this.isDuplicate).subscribe(res => {
        this.spinnerService.setShowFlag(false);
        this.saving = false;
        this.dialogRef.close(true);
      }, err => this.spinnerService.setShowFlag(false));
    }
  }

  optionIsHidden(option) {
    if (!option.EsPosicion) return false;
    if (this.entrega && (option.ID_POS === this.entrega.ID_POS)) return false;

    // Ocultar la posición del mes actual si no estamos en el primer día hábil
    if (!this.firstBusinessDay) {
      let filterLabel = this.commonService.getCurrentPosicionShortName();
      if (filterLabel === option.Posicion) {
        return true
      }
    }
    return this.firstDayMonthTime > option.Time;
  }

  isFormValid() {

    if (!this.entrega || !this.negocio.Toneladas || !this.negocio.Base) {
      return false;
    }

    let tmpEntrega = this.entrega && this.entrega.EsPosicion ? this.entrega.ID_POS : this.entrega.ID;
    return this.negocio.TipoNegocioId &&
      this.negocio.ProductoId &&
      this.negocio.CosechaId &&
      this.negocio.Toneladas && this.negocio.Toneladas.length && this.stringToNumber(this.negocio.Toneladas) > 0 &&
      this.negocioTipo &&
      typeof tmpEntrega === 'number' &&
      this.negocio.Base && this.negocio.Base.length &&
      this.negocio.MonedaId &&
	  this.acopioSelector.selectedItem > 0 &&
      this.cuentaAutocompleteComponent.selectedCuentas.length > 0 &&
      (this.negocio.TipoNegocioId === this.NEGOCIO_OLVIDADO_ID ?
        this.negocio.Observaciones && this.negocio.Observaciones.toString().trim().length > 0 && this.negocio.FechaCreacion : true) &&
      !this.cuentaAcopioError &&
      this.negocio.MercadoId;
  }

  changedNegocio(e) {

    this.currentMonedaOptions = this.monedaOptions;

    if (e.value === 'DISPONIBLE') {
      this.currentEntregaOptions = this.entregaOptions.filter(x => x.Tipo === 'Entrega');
    } else if (e.value === 'FORWARD') {
      this.currentEntregaOptions = this.entregaOptions.filter(x => x.Tipo === "Posicion" && x.Entrega_Id === 3);
    } else if (e.value === 'PAGO_DIFERIDO') {
      this.currentEntregaOptions = this.entregaOptions.filter(x => x.Tipo === "Posicion" && x.Entrega_Id === 4);
    } else {
      this.currentEntregaOptions = this.entregaOptions;
    }

    if (e.value !== 'DISPONIBLE') {
      this.currentMonedaOptions = this.currentMonedaOptions.filter(x => x.ID !== -1);
      if (this.negocio['MonedaId'] && this.negocio['MonedaId'] === -1) {
        delete this.negocio['MonedaId'];
      }
    }

    this.entrega = this.entrega && this.currentEntregaOptions.find(o => o.ID ? o.ID === this.entrega.ID : o.ID_POS === this.entrega.ID_POS);
  }

  showVencimientoDatePicker() {
    // No se puede editar la fecha de vencimiento en negocios olvidados
    if (this.negocio['TipoNegocioId'] !== 6) {
      this.vencimientoDatePicker.open();
    }
  }

  autogrow() {
    this.observacionRows = Math.ceil(this.observacionArea.nativeElement.scrollHeight / 32);
  }

  updateMaxNotif(e) {
    this.maxNotif = e.value === 1 ? 24 : (e.value === 24 ? 30 : 16);
  }

  // TODO: toda esta lógica puede ser agregada a una directiva si es que debemos replicarlo en otras
  // pantallas del sitio. Ver branch AAUF-888 para ver los cambios que se introdujeron
  interceptInput(e, field) {
    const acceptedKeyCodes = [8, 9, 13, 16, 27, 35, 36, 37, 39, 46, 188];

    //Si quiero poner una coma y ya existe en el texto entonces tiene que rebotar
    if(e.keyCode == 188 && (e.target.value.indexOf(',') >= 0)){
      e.stopPropagation();
      return false;
    }

    // Si el caracter ingresado no es un caracter de control permitido (backspace, tab, esc, etc)
    // ni tampoco es un dígito o coma, entonces detenemos la ejecución aquí. Y como esto está bindeado en el evento
    // keydown el ngModel no se actualizará con ese caracter inválido que ingresamos
    if (!(/\d/.test(e.key)) && acceptedKeyCodes.indexOf(e.keyCode) < 0) {
      e.stopPropagation();
      return false;
    }

    if(field && field == 'Toneladas'){
      const parts = this.negocio.Toneladas.split(',');
      const integer = parts[0];
      const decimal = parts[1];

      //se aceptan 3 decimales nomas
      if(acceptedKeyCodes.indexOf(e.keyCode) < 0 && decimal && decimal.length > 2){
        e.stopPropagation();
        return false;
      }
    }
  }

  addMagnitudePoints(model, e?) {
    // Actualizar el valor agregando puntos, si es que el caracter ingresado fue un digito.
    // O si el modelo cambió. Por eso también lo bindeamos en el evento ngModelChange pero sin pasar un
    // objeto evento así diferenciamos entre uno y otro caso
    if (!e || (/\d|,/.test(e.key))) {
      const parts = this.negocio[model].split(',');
      const integer = parts[0];
      const decimal = parts[1];
      this.negocio[model] = integer.replace(/\./g, '').split('').map((c,i,a) =>
        (((a.length - i) % 3) === 1) && a.length - i -1 >= 3 ? c+'.' : c
      ).join('') + (decimal && decimal.length ? ','+decimal : '');
    }
  }

  // si el producto cambia en el form, checkear que los colaboradores puedan ver el producto
  productoChanged(e) {
    this.colaboradorAutocompleteComponent.productoSelected = e.value;
    this.colaboradorAutocompleteComponent.checkAll();
  }

  // recibe un bool de un evento segun si todos los colaboradores pueden ver o no el producto
  validarColaboradores(e) {
    this.colaboradoresValid = e.allValid;
  }

  onClienteSelected(idToSelect: number = null) {
    if (this.cuentaAutocompleteComponent.selectedCuentas.length) {
      // buscamos el acopio para el cliente seleccionado
      this.negociosService.getAcopiosByCliente(this.cuentaAutocompleteComponent.selectedCuentas[0].Id)
        .subscribe(x => {
        if (x.length) {
          this.acopioSelectorItems = x;
          this.acopioSelector.ItemsList = x.map(y => ({
            Nombre: y.AcopioNombre,
            Id: y.Id
          }));
          if (idToSelect !== null) {
            this.acopioSelector.selectedItem = idToSelect;
          } else if (this.isEdit || this.isDuplicate) {
            // dado que para estos estados, deshabilitamos la seleccion automatica, debemos seleccionar manualmente la primara opcion en caso de haber cambiado el cliente
            this.acopioSelector.selectedItem = x[0].Id;
          }
          this.searchCuentaSaldo();
          this.checkCuentaAcopioValid();
        }
      });
    } else {
      this.acopioSelector.clearAllData();
      this.clienteSaldoListComponent.clearSaldo();
      this.checkCuentaAcopioValid();
    }
  }

  searchCuentaSaldo() {
    if (this.cuentaAutocompleteComponent.selectedCuentas.length &&
      this.acopioSelector.selectedItem !== null) {
      this.clienteSaldoListComponent.searchSaldo(
        {
          cliente: this.cuentaAutocompleteComponent.selectedCuentas[0].Id,
          acopio: this.acopioSelector.selectedItem
        });
    } else {
      this.clienteSaldoListComponent.clearSaldo();
    }
  }

  showCreacionDatePicker() {
    this.creacionDatePicker.open();
  }

  acopioSelectorDisabled() {
    return this.matcheadaFlag || this.cuentaAutocompleteComponent.selectedCuentas.length === 0;
  }

  tipoNegChanged(e) {
    // para negocios olvidados, seteamos la fecha de vencimiento a HOY, de lo contrario limpiamos el vencimiento
    if (e.value === 6) {
      this.negocio['Vencimiento'] = moment().toDate();
      this.observPlace = 'Observaciones *';
    } else {
      delete this.negocio['Vencimiento'];
      this.observPlace = 'Observaciones';
    }
  }

  onInputTnsBlur() {
    if (this.negocio['Toneladas'].length > 0) {
      // en caso de se haya puesto una coma al final sin los valores decimales, la quitamos
      if (this.negocio['Toneladas'].indexOf(',') === this.negocio['Toneladas'].length - 1) {
        this.negocio['Toneladas'] = this.negocio['Toneladas'].substring(0, -1);
      }
      // verificamos que el numero sea valido
      let val = this.negocio['Toneladas'];
      val = val.replace('.', '');
      val = val.replace(',', '.');
      if (!isNaN(Number(val))) {
        this.showTnsSpan = true;
      }
    }
  }

  openInput() {
    this.showTnsSpan = false;
    setTimeout(() => {
      this.tnsInput.nativeElement.focus();
    }, 100);
  }

  checkCuentaAcopioValid() {
    this.cuentaAcopioError = false;
    // Verificamos que para la cuenta y el acopio elegido, que exista el numero cuenta-acopio (el famoso MAPC)
    if (this.cuentaAutocompleteComponent.selectedCuentas.length && this.acopioSelector.selectedItem !== null) {
      // segun el acopio elegido, primero verificamos si es saltelite, si lo es, vamos a la central.
      const acopio = this.acopioSelectorItems.find(x => x.Id === this.acopioSelector.selectedItem);
      const acopioId = acopio.Parent !== null ? acopio.Parent.Id : acopio.Id;

      // una vez seleccionado, verificamos en los datos del acopio, que exista el valor cuenta-acopio para el acopio elegido.
      this.cuentaAcopioError = this.cuentaAutocompleteComponent.selectedCuentas[0].CuentaAcopio.find(x => x.AcopíoID === acopioId).CuentaAcopio === 0;

    }
  }

  validarNegOlvidado() {
    this.spinnerService.setShowFlag(true);
    const payload = {...this.negocio};
    if (this.negocioTipo === 'DISPONIBLE') {
      payload.EntregaId = this.entrega.ID;
      payload.NegocioTipoPosicionId = null;
    } else if (this.negocioTipo === 'FORWARD') {
      payload.EntregaId = this.forwardNegocioID;
      payload.NegocioTipoPosicionId = this.entrega.ID_POS;
    } else if (this.negocioTipo === 'PAGO_DIFERIDO') {
      payload.EntregaId = this.entrega.Entrega_Id;
      payload.NegocioTipoPosicionId = this.entrega.ID_POS;
    }
    payload.Pesificar = payload.MonedaId === DOLAR_PESOS_ID ? 1 : 0;
    payload.Base = Number(this.negocio['Base'].replace(/[^0-9|,]/g, '').replace(',', '.'));
    payload.Toneladas = Number(this.negocio['Toneladas'].replace(/[^0-9|,]/g, '').replace(',', '.'));
    this.negociosService.validarNegOlvidado(payload).subscribe(res => {
      this.spinnerService.setShowFlag(false);
      if (res === '') {
        this.negocioOlvidadoValidado = true;
        this.onSubmit();
      } else {
        // no podemos importal el dialog service dado que se genera una dependencia circular
        // por lo que debemos instanciar el componente manualmente
        let dialogRef: MdDialogRef<TextDialogComponent>;
        dialogRef = this.dialog.open(TextDialogComponent);
        dialogRef.componentInstance.title = 'No es posible crear el Negocio Olvidado';
        dialogRef.componentInstance.message = res;
        dialogRef.componentInstance.positiveText = 'Aceptar';
        dialogRef.componentInstance.showNegativeButton = false;
        this.negocioOlvidadoValidado = null;
      }
    }, err => this.spinnerService.setShowFlag(false));
  }

  getToneladasErr(): boolean {
    // usamos esa comparacion a cero porque si igualamos a cero, al poner muchos ceros se vuelve true
    return this.negocio.Toneladas && this.negocio.Toneladas.length && !(this.stringToNumber(this.negocio.Toneladas) > 0);
  }

  stringToNumber(val: string): number {
    // dado que javascript no sabe lo mal que escribimos hacemos la conversion de puntos a comas
    // primero eliminamos lo que se encuentre que no sean numeros y comas, luego cambiamos la coma por un punto
    return Number(val.replace(/[^0-9|,]/g, '').replace(',', '.'))
  }
  
  setupNegocioFromPrecio() {
    this.negocio['Base'] = this.fromPrecio.Precio;
    this.negocio['MercadoId'] = this.fromPrecio.PrecioRAW.Mercado.Id;
    this.negocio['ProductoId'] = this.fromPrecio.PrecioRAW.Producto.Id;
    this.negocio['MonedaId'] = this.fromPrecio.PrecioRAW.Moneda.Id;

    // verificamos el tipo de negocio
    // Entrega/Posición y Negocio
    if (this.fromPrecio.PrecioRAW.Entrega.Id === 3) {
      this.changedNegocio({ value: 'FORWARD' });
      this.negocioTipo = this.negocioOptions[1].value;
      this.entrega = this.entregaOptions.find(e => e.ID_POS === this.fromPrecio.PrecioRAW.Posicion.Id);
    } else if (this.fromPrecio.PrecioRAW.Entrega.Id === 4) {
      this.changedNegocio({ value: 'PAGO_DIFERIDO' });
      this.negocioTipo = this.negocioOptions[2].value;
      this.entrega = this.entregaOptions.find(e => e.ID_POS === this.fromPrecio.PrecioRAW.Posicion.Id);
    } else {
      this.changedNegocio({ value: 'DISPONIBLE' });
      this.negocioTipo = this.negocioOptions[0].value;
      this.entrega = this.entregaOptions.find(e => e.ID === this.fromPrecio.PrecioRAW.Entrega.Id);
    }
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/new-negocio-dialog/new-negocio-dialog.component.ts